import React from 'react';
import style from './style.module.scss';

/**
 * Renders the booking tags
 */
export const BookingTags: React.FC<unknown[]> = (props) => {

  // Do not proceed, when no tags are provided
  const tagList = Object.values(props);
  if (tagList.length === 0) return null;

  // Iterate through each tag
  const tags = tagList.map((item: any, index) => {
    return (
        <div key={index} className={style.tagContent}>
          <img className={style.tagIcon} src={`../../../images/tags/${item.icon}.svg`}/>
          <span>{item.name}</span>
        </div>
    )
  });

  return (
    <>
      <p className={style.summaryLabel}>Tags</p>
      <div className={style.tagContainer}>{tags}</div>
      <hr className={style.summaryHorizontalLine} />
    </>
  );

};